import RecipesTableToolbar from './RecipesTableToolbar';

export default RecipesTableToolbar;
